import { entryChannels } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function EntryChannels() {
  return (
    <section id="entry-channel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <Reveal>
        <SectionHeading
          tag="官网入口"
          title="先分清「入口」和「地址」，再决定从哪里进"
          desc="入口是进入的通道，地址是当下可用的具体网址。认准官方入口，就能在地址变化时依然找到正确的方向，而不是每次重新碰运气。"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <Reveal className="lg:col-span-4" delay={60}>
          <div className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
            <h3 className="font-heading font-bold text-foreground-950 text-lg flex items-center gap-2">
              <i className="ri-lightbulb-flash-line text-accent-500"></i>
              一句话理解入口
            </h3>
            <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
              把官方入口理解成「唯一的正规大门」，把最新地址理解成「这扇门当前的门牌号」。
              门牌号会换，但门始终是同一扇。只要认准门口，就不怕走错。
            </p>
            <ul className="mt-5 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-2.5">
                <i className="ri-check-line text-primary-600 mt-0.5"></i>
                认准入口再获取地址，不靠搜索碰运气
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-check-line text-primary-600 mt-0.5"></i>
                核对域名再访问，避免进入仿冒页
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-check-line text-primary-600 mt-0.5"></i>
                收藏入口 + 备用地址，一次到位
              </li>
            </ul>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-8" delay={120}>
          <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-background-200 bg-background-100/60">
              <h3 className="font-heading font-bold text-foreground-950 text-base">
                四类常见进入方式对照
              </h3>
              <span className="text-xs font-label text-foreground-500">按需选择</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[560px] text-left text-sm">
                <thead>
                  <tr className="text-foreground-500 font-label text-xs">
                    <th className="px-5 py-3 font-medium">进入方式</th>
                    <th className="px-5 py-3 font-medium">主要特点</th>
                    <th className="px-5 py-3 font-medium">适合场景</th>
                    <th className="px-5 py-3 font-medium">注意事项</th>
                  </tr>
                </thead>
                <tbody>
                  {entryChannels.map((row) => (
                    <tr key={row.name} className="border-t border-background-200">
                      <td className="px-5 py-4 font-medium text-foreground-900 whitespace-nowrap">
                        {row.name}
                      </td>
                      <td className="px-5 py-4 text-foreground-700">{row.traits}</td>
                      <td className="px-5 py-4 text-foreground-700">{row.scene}</td>
                      <td className="px-5 py-4 text-foreground-600">{row.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-5 py-4 border-t border-background-200 bg-secondary-50">
              <p className="text-sm text-secondary-900 flex items-start gap-2">
                <i className="ri-information-line mt-0.5"></i>
                不同进入方式的体验差异主要来自安装成本、缓存能力与提醒功能，选择时按自己的使用频率决定即可。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}